<template>
  <v-card class="mb-4">
    <!-- <v-progress-linear
      class="ma-auto"
      v-show="loading"
      :indeterminate="true"
    /> -->

    <v-toolbar dense>
      <v-toolbar-title>
        Conditions
      </v-toolbar-title>
      <v-spacer />
      <edit-resource-button
        resource-label="Scope Condition"
        resource-name="conditionsonscopeofpractice"
        :resource="newCondition"
        :filter="{ where: { personid: personId } }"
        resource-id-field="conditiononscopeid"
        :resource-id="['conditiononscopeid']"
        :create-new="true"
        @save="loadResources()"
      >
        <template slot-scope="editProps">
          <my-form :item="editProps.item"></my-form>
        </template>
      </edit-resource-button>
      <v-btn icon @click="loadResources">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <div v-if="errors.length > 0">
      <v-alert v-for="message in errors" :key="message" type="error">
        {{ message }}
      </v-alert>
    </div>

    <v-data-table
      dense
      :items="allResources"
      :headers="tableHeaders"
      item-key="conditiononscopeid"
      :loading="$store.getters.isLoading"
      :options.sync="options"
    >
      <template v-slot:item="props">
        <tr>
          <td>
            {{ props.item.dateadded | formatDate }}
          </td>

          <td>
            <span v-if="props.item.datemet">
              <v-icon color="success">check</v-icon> ({{
                props.item.datemet | formatDate
              }})
            </span>
            <v-icon v-else color="error">remove</v-icon>
          </td>

          <td>
            {{ lookup("ScopesOfPractice", props.item.scopeofpracticeid) }}
          </td>

          <!-- <td>{{props.item.datemet | formatDate}}</td> -->

          <!-- <td>
          <v-icon v-if="!props.item.commentsconfidential">remove</v-icon>
          <v-icon v-else>check</v-icon>
        </td> -->
          <td>
            {{ props.item.comments }} |
            {{ lookup("ConditionTypes", props.item.conditionid) }}
          </td>
          <td>
            <v-btn
              :to="`/people/${props.item.preceptorshipid}`"
              target="_blank"
              v-if="props.item.preceptorshipid"
            >
              {{ props.item.preceptorshipid }}
            </v-btn>
          </td>

          <td>
            <div>
              <edit-resource-button
                resource-label="Scope Condition"
                resource-name="conditionsonscopeofpractice"
                :resource="props.item"
                :filter="{ where: { personid: props.item.personid } }"
                resource-id-field="conditiononscopeid"
                :resource-id="['conditiononscopeid']"
                :create-new="false"
                @save="loadResources()"
              >
                <template slot-scope="editProps">
                  <my-form :item="editProps.item"></my-form>
                  <div v-if="currentUserCan('deleteConditions')">
                    <v-divider />
                    Admin options:
                    <br />
                    <delete-item-button
                      url="conditionsonscopeofpractice"
                      :itemid="props.item.conditiononscopeid"
                      @delete="loadResources"
                      :disabled="!currentUserCan('deleteConditions')"
                      color="red"
                    ></delete-item-button>
                  </div>
                </template>
              </edit-resource-button>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import myForm from "./form";
import deleteItemButton from "@/components/lib/delete-item-button";

export default {
  name: "scopeConditionsList",
  data() {
    return {
      person: {},
      practitioner: {},
      // allResources: [],
      apc: [],
      errors: [],

      options: {
        sortDesc: [true, true],
        sortBy: ["datemet", "dateadded"]
      },
      tableHeaders: [
        { text: "StartDate", value: "dateadded", width: "10em" },
        { text: "Met", value: "datemet", width: "6em" },
        { text: "Scope", value: "scopeofpracticeid" },
        { text: "ConditionDetails", sortable: false },
        { text: "Preceptor", sortable: false },
        { text: "", sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters({ lookup: "lookup" }),
    newCondition() {
      return {
        personid: this.personId,
        sopid: null,
        isinactive: true,
        scopedate: new Date()
      };
    },
    allResources() {
      return (
        this.$store.getters.getById(this.personId)?.practitioner
          ?.conditionsonscopeofpractice || []
      );
    }
  },
  methods: {
    async loadResources() {
      if (!this.personId) {
        this.errors.push("personid not defined");
        return;
      }

      await this.$store.dispatch("load", this.personId);
      // const person = this.$store.getters.getById(this.personId);
      // console.log("person: ", person);
      // this.allResources =
      //   person?.practitioner?.conditionsonscopeofpractice || [];

      // this.loading = true;
      // var reqs = [];

      // reqs.push(
      //   this.$http
      //     .get("/conditionsonscopeofpractice", {
      //       params: {
      //         filter: { where: { personid: this.personId } }
      //       }
      //     })
      //     .then(response => {
      //       this.loading = false;
      //       this.allResources = [...response.data];
      //       this.errors = [];
      //     })
      //     .catch(e => {
      //       this.loading = false;
      //       this.handleError(e);
      //     })
      // );
    },
    handleError(e) {
      this.errors.push(e.message);
    }
  },
  props: {
    personId: String
  },
  watch: {
    personId: {
      handler: "loadResources",
      immediate: true
    }
  },
  filters: {
    currency(amount) {
      return "$" + amount;
    }
  },
  components: {
    myForm,
    deleteItemButton
  }
};
</script>
